export enum ImageTypesEnum {
  IMAGE,
  ICON,
  NO_IMAGE,
}
